import API from '@/network/API'
import { CustomSuccessData } from 'axios'

const url = '/user/v1.0/firebase/anonymous/token'

export default function (): Promise<CustomSuccessData<{token: string}>> {
  return API.instance().put<{token: string}>(url, undefined, { isAuthorization: false })
}
